import React from 'react';
import { Loader } from '../../../components';
import CoursesTitle from '../courses-title';
import CourseCard from '../course-card';
import './styles.scss';

const CoursesHorizontalList = ({
  topTitle,
  mainTitle,
  courses,
  onPlayCoursePreview,
  isLoading,
  isAvailableCourses,
}) => {
  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="courses-horizontal-list">
      <div className="courses-horizontal-list__header">
        <CoursesTitle topTitle={topTitle} mainTitle={mainTitle} isAvailableCourses={isAvailableCourses} />
      </div>
      <div className="courses-horizontal-list__items-wrapper">
        {courses.map(course => (
          <CourseCard key={course.id} course={course} onPlayCoursePreview={onPlayCoursePreview} />
        ))}
      </div>
    </div>
  );
};

export default CoursesHorizontalList;
